import styled from "styled-components";

export const Header = styled.header`
  max-width: 1200px;
  margin: 40px auto;
  padding: 0 20px;

  @media screen and (max-width: 1024px) {
    margin: 30px auto;
  }

  @media screen and (max-width: 768px) {
    margin: 20px auto;
  }
`;

export const Headline = styled.h2`
  color: #556677;
  font-size: 1.6em;
  font-weight: 700;
  margin-bottom: 8px;

  @media screen and (max-width: 1024px) {
    font-size: 1.2em;
  }

  @media screen and (max-width: 768px) {
    font-size: 1em;
  }
`;

export const Title = styled.h2`
  font-size: 2em;
  font-weight: 700;

  @media screen and (max-width: 1024px) {
    font-size: 1.5em;
  }

  @media screen and (max-width: 768px) {
    font-size: 1.25em;
  }
`;
